module.exports = __webpack_public_path__ + "img/diagnostic-history-section-fr.4fb96fa3.jpg";